import { Badge, Link, ListItem, OrderedList, Table, Tbody, Td, Text, Th, Thead, Tr } from '@chakra-ui/react';
import LocalizedStrings from 'react-localization';
import { TutorialModalLink } from '../components/TutorialModalTrigger';

// import {/*GoVerified, */GoUnverified} from 'react-icons/go';
import { mailAddressSuffix } from '../common/constants';
// const BLOCKCHAIN_NAME_CAMEL = 'Avalanche';
const BLOCKCHAIN_NAME_CAMEL = 'ICP';

// const BLOCKCHAIN_NAME_LOWERCASED = 'ethereum';
const MAINNET_NAME = 'Mainnet';
const TESTNET_NAME = 'Fuji';
const DEFAULT_NET_NAME = TESTNET_NAME;
const COIN_SYMBOL = 'AVAX'; // ETH
// https://Sepoliafaucet.com
const FAUCET_URL = 'https://faucet.avax.network/'
const browserName = (function (agent) {
    switch (true) {
        case agent.indexOf("edge") > -1: return "MS Edge";
        case agent.indexOf("edg/") > -1: return "Edge (chromium based)";
        case agent.indexOf("opr") > -1 && !!window.opr: return "Opera";
        case agent.indexOf("chrome") > -1 && !!window.chrome: return "Chrome";
        case agent.indexOf("trident") > -1: return "MS IE";
        case agent.indexOf("firefox") > -1: return "Mozilla Firefox";
        case agent.indexOf("safari") > -1: return "Safari";
        default: return "other";
    };
})(window.navigator.userAgent.toLowerCase());

const Strings = new LocalizedStrings({
    en: {
        appName: "PlexiMail",
        error: {
            rpc: {
                '-32002': 'Your request is queued behind a pending one for your wallet, which may be hidden beneath other windows. Recover your wallet app and clear the pending entries first.',
            },
            client: {
                miss_param: 'Missing data parameter',
                miss_signature: 'Missing signature parameter',
                invalid_signature: 'Invalid signature',
                not_in_blockchain: ' not found in blockchain',
                name_empty: 'Name must not be empty',
                email_empty: 'Invalid PlexiMail address',
                contact_already_existed: 'Contact entry already exists',
                invalid_signal_message: 'SysError (Invalid Signal message)',
                invalid_message_type: 'SysError (Invalid message type)',
                prekey_message_not_found: 'SysError (PreKey message Not Found)',
                enc_data_undefined: 'SysError (Encryption data not found)',
                enc_data_null: 'SysError (Encryption data not found)',
                unsupported_data_type_1: 'data type ',
                unsupported_data_type_2: ' is unsupported',
                plaintext_null: 'SysError (Encryption data must not be null)',
                failed_clear_cache: 'SysError (Failed to clear the cache)',
                lost_conn: 'Connection lost',
                ws_not_ready: 'SysError (Web socket not ready)',
                att_not_bob: 'SysError (attachment is not of Blob type)',
                enckey_bundle_not_found: 'SysError (EncryptionKey Bundle not found)',
                enckey_for_att_not_found_1: 'SysError (EncryptionKey for attachment ',
                enckey_for_att_not_found_2: ' not found)',
                enckey_for_msg_not_found_1: 'SysError (Encryption Key for message "',
                enckey_for_msg_not_found_2: '" not found)',
                metamask_not_installed: 'MetaMask not installed',
                wallet_not_found: 'Wallet not found',
                idkey_not_found: 'SysError (Identity key-pair not found)',
                devid_lost: 'Device ID not found',
                regid_lost: 'Registration ID not found',
                idkey_lost: 'Identity key-pair not found',
                msg_is_null: 'Message must not be empty',
                unsupported_msg_type: 'Unsupported message type',
                file_not_found: 'File not found ',
                timeout_retry: 'Error or timeout: click to retry or exit for now.',
                idkey_not_identical: 'Identity Keys not matching',
                account_not_in_blockchain: 'Account not found on blockchain',
            }
        },
        common: {
            message: {
                supply_prekeys: 'Supply prekeys...',
                generate_keys: 'Generating Identity Key, registration id, and prekeys...',
                save_prekey: 'Storing PreKey bundle into cloud...',
                save_idkey: 'Saving Identity Key into smart contract...',
                wait_tx_receipt: 'Wait for transaction receipt...',
                save_signal: 'Saving signal protocol store...',
                completed: 'Completed!',
                wallet_is_backup: 'Your self-managed account has been generated and your PlexiMail identities created.',
                wallet_safe_smart_contract: 'Your wallet is securely stored in your private storage. Its corresponding PlexiMail Identity is registered on the ICP blockchain for self-managed and anonymous auditability. Remember to safeguard your double locks. Explore Settings to choose additional security and audit options.',
                checking_balance: `Checking ${COIN_SYMBOL} account balance...`,
                wait_funds: 'pending on the external funding actions ...',
                incorrect_password: 'PIN Code is incorrect',
                init_web3_storage: 'Initializing Web3 Storage...',
                backup_wallet: 'Backup your wallet ...',
            }
        },
        app: {
            mode: {
                unverified: 'Unverified',
                verified: 'Verified by ICP',
            },
            privacy_level: {
                standard: 'Standard Privacy',
                high: 'High Privacy'
            },
            message: {
                ready: 'Ready!',
                new_message: 'New incoming messages!',
                prepare_signal: 'Preparing signal environment...',
                check_prekeys: 'Checking prekeys. Please wait...',
                generate_prekeys: 'Generating prekeys. Please wait...',
                save_prekeys: 'Saving prekeys. Please wait...',
                load_contact: 'Loading contacts. Please wait...',
                load_messages: 'Loading PlexiMails. Please wait...'
            },
            dialog: {
                search: {
                    title: 'Search Messages',
                    search: 'Search',
                    noResults: 'No Results',
                    noBackup: 'No Backup'
                },
                ask_pwd: {
                    title: 'Passcode is required',
                    description: 'The message is encrypted and requires a passcode to unlock, which will be sent to you via SMS or another secure delivery path per prior arrangement. If you possess the passcode, click the button below to unlock the message.',
                    passcode_label: 'Please enter passcode here',
                    passcode_placeholder: 'xxxx xxxx xxxx xxxx',
                    next: 'Next',
                    cancel: 'Cancel',
                },
                faucet: {
                    title: 'Activate Self-Managed Account',
                    message: {
                        back: 'Please fill your wallet with sufficient cryptos before resuming this configuration process.'
                    },
                    content: {
                        paragraph1: 'You have successfully created a PlexiMail wallet for maintaining your PlexiMail identity and acquired your Web3 storage. Now you need to register a secured set of contact parameters through the PlexiMail Smart Contract for your partners to reach you when allowed. Additionally, all your asynchronous messaging context will be encapsulated in a configuration database, also stored in your Web3 storage and doubly locked. To enable this self-managed PlexiMail account, you will be asked to:',
                        paragraph2: <OrderedList mt={3} paddingX={8} fontWeight={"bold"} fontSize={{ base: 'sm', lg: 'sm' }}>
                        <ListItem>Fund your wallet with cryptos if you opt to register with PlexiMail Smart Contract to maximize protection.</ListItem>
                        <ListItem>Provide the double locks to protect your configuration.</ListItem>
                      </OrderedList>,
                      paragraph3: `Note: PlexiMail is free only in the sense that this PlexiMail software is freely offered for non-commercial use, but the incurred consumables, like electricity, computing power, traditional disk storage, RAM, printer, ink, Internet connectivity, etc., are not. As a Web3 dApp running on ${BLOCKCHAIN_NAME_CAMEL} blockchain, it consumes “${BLOCKCHAIN_NAME_CAMEL} gas” for running the smart contract, which is the charge by the ${BLOCKCHAIN_NAME_CAMEL} for your consumption of its computational resources. The initial smart contract run costs gas and a nominal charge of $.0001 per sent email is assessed to thwart DDOS when deemed necessary.`
                    },
                    button: {
                        get_coins: 'Enter Smart Contract',
                        buy_with_ecash: 'Activate the contract with anonymized Plexi Tokens',
                        redeem_promo_code: 'Activate the contract with Promo Code',
                        buy: 'Activate the contract through a crypto exchange',
                        get: 'Activate',
                        email: 'Activate by sending a request',
                        show_wallet: 'Show Wallet'
                    }
                },
                kickout: {
                    title: 'App has been reset',
                    message: 'Since you have already signed in on another device, the data on this device has been cleared.',
                    quit: 'Quit'
                },
                af_faucet: {
                    title: 'Apply for Test Coins',
                    description: 'Enter email address to see if you qualify for the promotional PlexiMail start-up test coins:',
                    description2: 'A confirmation email will be sent to the mailbox entered to validate your email address.',
                    email: 'Email Address',
                    email_placeholder: 'Please enter email here',
                    cancel: 'Cancel',
                    request: 'Request',
                    menu_item: 'Get Test Coins with Email',
                    note: '* Alternatively, you can get test coins yourself directly from'
                },
                exit_setup: {
                    title: 'Are you sure you want to exit the configuration wizard ?',
                    message: 'This wizard will start over if you exit.',
                    cancel: 'Cancel',
                    exit: 'Exit'
                },
                promo_code: {
                    title: 'Redeem a Promo Code',
                    description: `Enter your one-time Promo Code (optional) to try out with external resources from a shared pool, like ${COIN_SYMBOL} cryptos for testnet and an API Token for Web3 cloud storage, without configuring them in yourself. Some restrictions apply.`,
                    cancel: 'Cancel',
                    redeem: 'Redeem',
                    waiting: 'Waiting for Transaction Receipt ...',
                    redeeming: 'Redeeming Promo Code ...',
                    rejected: 'Transaction is rejected',
                    redeemed: 'Promo Code has been redeemed.'
                },
                address_verify_popup: {
                    
                    verified: {
                        title: 'Verified by ICP',
                        message: 'The recipient has been verified to own the PlexiMail address registered through the PlexiMail Smart Contract.',
                        sender_message: 'The sender has been verified to own the PlexiMail address registered through the PlexiMail Smart Contract.',
                        self_message: 'Your PlexiMail Address is currently in the "Verified by ICP" status, no additional burden to authenticate you with the advantages provided by registering with the PlexiMail Smart Contract.',
                    },
                    unverified: { 
                        title: 'Unverified',
                        message: 'The ownership of the recipient\'s address is not verifiable through the PlexiMail Smart Contract. ',
                        sender_message: 'The ownership of the sender\'s address is not verifiable through the PlexiMail Smart Contract. ',
                        self_message: 'Your PlexiMail Address is currently in the "Unverified" status, placing additional burden on your partners to authenticate you with the advantages provided by registering with the PlexiMail Smart Contract.',
                        
                    },
                    warning: {
                        trigger: "Skip Smart Contract",
                        confirmation: "I understand the risk",
                        title: "Skip Smart Contract",
                        message: "You can store your Identity Key on the blockchain to significantly reduce the risk of identity theft, although it comes with the associated cost around $1 of registering through the smart contract on Avalanche. You can always create multiple accounts and choose a separate option for each account based on its assessed level of risk. "
                    }
                },
                activate_account: {
                    trigger: 'Register with Smart Contract',
                    get_start: {
                        title: 'Register',
                        description: <>
                        <Text mt={"20px"} fontSize={"xs"} color={"gray.600"}>
                        You haven't been verified to own the PlexiMail address by registering with the PlexiMail Smart Contract.
                        </Text>
                        </>,
                        description_upgrade: <>
                        <Text mt={"20px"} fontSize={"xs"} color={"gray.600"}>
                        You haven't been verified to own the PlexiMail address by registering with the PlexiMail Smart Contract on the Mainnet.
                        </Text>
                        </>,
                        button: {
                            cancel: 'Cancel',
                            next: 'Register',
                            upgrade: 'Upgrade'
                        }
                    },
                    select_network: {
                        title: 'Select Blockchain',
                        description: 'PlexiMail adopts the self-executing smart contract to register and protect the PlexiMail addresses/identities. Once registered, the authenticity of a PlexiMail identity becomes auditable without a central authority and inalterable without owning the private key.',
                        mainnet: 'Mainnet',
                        mainnet_note: '* Pay AVAX crypto to register your PlexiMail addresses on the Avalanche Mainnet.',
                        testnet: 'Testnet',
                        testnet_note: '* Conduct a test run on the Fuji Testnet without incurring AVAX charges. Your PlexiMail addresses are not fully protected in this case. You may upgrade your run to the Mainnet later.',
                        button: {
                            back: 'Back',
                            next: 'Next'
                        }
                    },
                    check_balance: {
                        title: 'Fund the Registration',
                        message: {
                            back: 'Please ensure that your wallet is filled with sufficient cryptocurrencies before resuming this configuration process.',
                            no_enough_eth: `Not enough ${COIN_SYMBOL} in your wallet to register your identity with the Smart Contract. Click "Buy ${COIN_SYMBOL}" to refill your wallet.`,
                            ready: 'Click "Next" to publish your PlexiMail address with PlexiMail Smart Contract.'
                        },
                        description: <>
                        <Text mt={"20px"} fontSize={{ base: 'xs', lg: 'xs' }} color={"gray.600"}>
                        For your partners to reach you when allowed and for trustless auditability, you need to register a secured set of contact parameters through the PlexiMail Smart Contract.
                        </Text>
                        <Text mt={"20px"} fontWeight={"bold"} fontSize={{ base: 'xs', lg: 'xs' }}>
                        It costs transaction fees in cryptos to register with the Smart Contract in order to maximize the protection of your PlexiMail identities.
                        </Text>
                        </>,
                        button: {

                            back: 'Back',
                            previous: 'Previous',
                            next: 'Next',
                            check: 'Check Balance'
                        },
                        menu: {
                            trigger: `Buy ${COIN_SYMBOL}`,
                            items: {
                                token: `Buy ${COIN_SYMBOL} with Plexi tokens`,
                                exchange: `Buy ${COIN_SYMBOL} with Exchange`,
                                email: 'Request Test Coin through Email'
                            }
                        }
                    },
                    save_idkey: {
                        title: 'Save Identity Key through Smart Contract',
                        description: <>
                        <Text mt={"20px"} fontSize={"xs"} color={"gray.600"}>
                        We adopt the Signal Protocol to protect your end-to-end communication sessions. Your PlexiMail addresses are bound to the private keys in your wallet at this step, which spawns a full spectrum of session keys and other security parameters as per situations.
                        </Text>
                        <Text mt={"20px"} fontSize={"xs"} color={"gray.600"}>
                        You may need to sign the confirmation transaction pop-up with keys from your {BLOCKCHAIN_NAME_CAMEL} wallet.
                        </Text>
                        </>,
                        button: {
                            previous: 'Previous',
                            next: 'Next'
                        }
                    },
                    wait_receipt: {
                        title: 'Waiting For Transaction Receipt',
                        description: <>
                        <Text mt={"20px"} fontSize={"xs"} color={"gray.600"}>
                        Your PlexiMail address and session data are safeguarded on the {BLOCKCHAIN_NAME_CAMEL} Blockchain through a Smart Contract. Please wait until this process completes. 
                        </Text>
                        </>,
                        high_privacy_warning: <>
                        <Text mt={2} fontSize={"xs"} color={"gray.600"}>
                        Clicking "Done" will refresh the web page. Since the application is currently running at a high privacy level, you can only return to this account through "Recovery" after the web page has been reloaded.
                        </Text>
                        </>,
                        button: {
                            previous: 'Previous',
                            next: 'Done'
                        },
                        message: {
                            checking: 'Checking transaction receipt... ',
                            failed: 'Failed to get the transaction receipt. Please try again later.',
                            confirmed: 'Transaction has been confirmed'
                        }
                    }
                },
                indexeddb: {
                    tor: {
                        title: 'Tor browser is not yet supported',
                        description: <Text>
                            PlexiMail cannot run in Tor Browser because it doesn't support indexeddb by default. If you want the get the private that tor browser brings, it is recommended to visit PlexiMail in <Link href="https://brave.com" target="_blank" color="#00aaff">Brave</Link>.
                        </Text>
                    },
                    normal: {
                        title: 'Current browser is not yet support',
                        description: <Text>
                        PlexiMail cannot run in current browser because it doesn't support indexeddb. It is recommended to visit PlexiMail in <Link href="https://www.google.com/chrome" target="_blank" color="#00aaff">Chrome</Link>.
                    </Text>
                    }
                },
                privacy_level: {
                    title: 'Privacy Level',
                    description: 'Usability and privacy often involve a trade-off, as higher privacy measures can result in a less user-friendly experience. We offer two privacy levels to accommodate different preferences:',
                    tor_warning: 'Tor browser only supports "High" Level of privacy',
                    normal_warning: 'The current browser only supports the "High" Level of privacy.',
                    level: {
                        standard: {
                            title:'Standard',
                            description: 'The data generated by PlexiMail will be encrypted and stored in the browser\'s built-in database, persisting until the user exits.'
                        },
                        high: {
                            title: 'High',
                            description: 'The data generated by PlexiMail will only exist in memory at runtime.'
                        }

                    },
                    error: {
                        cancelled: 'Cancelled',
                    },
                    button: {
                        cancel: 'Cancel',
                        confirm: 'Confirm'
                    }
                }
            }
        },
        home: {
            // slide.1.paragraph.1
            promotion: {
                title: 'PlexiMail by Ai-Fi',
                content: {
                    paragraph1: ' - Secured End-To-End',
                    paragraph2: ' - No Metadata Leaking',
                    paragraph3: ' - No Size Limit',
                    paragraph4: ' - Open-Source and Forever Free **'
                }
            },
            signIn: {
                title_1: 'The',
                title_2: 'Trace Email',
                description_1: 'Distributed, Permissionless, Traceless and Invisible. ',
                description_2: `You can only reach your partners on the same network. The default is "${DEFAULT_NET_NAME}", a test network displayed on the upper right corner. You may change your network to "${MAINNET_NAME}", the primary public ${BLOCKCHAIN_NAME_CAMEL} blockchain network, or any other test network listed.`,
                description_3: 'Log in or register for a new PlexiMail Identity. This secure, anonymized technology safeguards your PlexiMail addresses and private keys on the transparent and secure ICP blockchain. It further minimizes data trails by cloaking all metadata, reinforcing strong anonymity for private communication.  ',
                description_3_continue: 'Generating a new PlexiMail account/address or importing from another wallet involves multiple steps. Kindly answer prompts patiently until completion.  ',
                note: <>
                ** Press the "Enter" below only if you agree with the <Link href="https://ai-fi.cc/terms-of-service.html" target="_blank" color="#00aaff"><i>PlexiMail Terms & Privacy Policy</i></Link>.</>,
                note_continue: <>
                ** Press the "Continue" below only if you agree with the <Link href="https://ai-fi.cc/terms-of-service.html" target="_blank" color="#00aaff"><i>PlexiMail Terms & Privacy Policy</i></Link>.</>,
                button: 'Enter with Internet Identity',
                one_click_resume: '1-Click Resume',
                try_live_demo: `Try Live Demo (${TESTNET_NAME})`,
                reset: 'Start Over',
                resume: 'Resume with Internet Identity',
                continue: 'Continue with Internet Identity',
                incomplete_setup_detected: 'Your previous configuration session did not complete. Recover it or start afresh?',
                switch_wallet: 'Switch Account'

            },
            business: {
                title_1: 'The',
                title_2: 'Trace Business',
                description_1: 'Simple, encrypted solutions to protect your business.',
                description_2: 'Advanced protection for your company’s emails, calendars, passwords, network, and more with our suite of secure business apps.',
                note: <>
                ** Press the "Enter" below only if you agree with the <Link href="https://ai-fi.cc/terms-of-service.html" target="_blank" color="#00aaff"><i>PlexiMail Terms & Privacy Policy</i></Link>.</>,
                note_continue: <>
                ** Press the "Continue" below only if you agree with the <Link href="https://ai-fi.cc/terms-of-service.html" target="_blank" color="#00aaff"><i>PlexiMail Terms & Privacy Policy</i></Link>.</>,
                
            },
            unlock: {
                title: 'Unlock with Password',
                title_pin: 'Unlock with PIN Code',
                idle_timeout: 'To unlock your cached session after an idle timeout',
                button: {
                    unlock: 'Unlock',
                    forgot: 'Forgot PIN or Reset?',
                    switch_wallet: 'Switch Account'
                }
            },
            dialog: {
                reset: {
                    title: 'Forgot the PIN',
                    content: {
                        paragraph1: 'Your previous email context maintained locally is only recoverable with the correct PIN.',
                        paragraph2: 'Press "Reset" to clear local cache in order to re-enter with your Crypton keys. A new entry allows PIN code reset.',
                    },
                    button: {
                        cancel: 'Cancel',
                        reset: 'Reset'
                    },
                    message: {

                    }
                },
                unsupported: {
                    title: browserName + ' is not yet supported',
                    content: {
                        paragraph1: 'Only the following browsers are supported now:',
                        paragraph2: 'Brave (Recommended)',
                        paragraph3: 'Chrome',
                        paragraph4: 'Edge',
                        paragraph5: 'Firefox',
                    },
                    button: {
                    }
                },
                notReady: {
                    title: 'PlexiMail requires MetaMask and Web3Storage',
                    content: {
                        paragraph1: 'You are about to enter into PlexiMail, the most advanced secure email dApp, enabled by the advent of Blockchain technology. You must first install a cryptocurrency wallet (MetaMask) and make available certain amount of cloud storage (Web3Storage).',
                        paragraph2: 'NOTE: Both MetaMask and Web3.Storage are well-trusted open source Web3 services. We hesitate to integrate them into our PlexiMail baseline to avoid muddying the water of their trustworthiness. They are also an ideal introduction to the brave new world of Web3 dApps. Please return here to try your free PlexiMail after the successful completion of their installation.',
                        paragraph3: 'You can skip this tutorial if you are an experienced web3 practitioner, otherwise we advise that you read through it.'
                    },
                    button: {
                        skip: 'Skip Tutorial',
                        read: 'Read Tutorial'
                    }
                },
                walletNotFound: {
                    title: 'MetaMask Wallet not Found',
                    content: {
                        paragraph1: `PlexiMail addresses are converted from your public keys associated with your ${BLOCKCHAIN_NAME_CAMEL} accounts, jointly managed with the MetaMask wallet. You need to fund those accounts with cryptocurrencies, as the email logic conducted through the PlexiMail Smart Contract incur charges in ${COIN_SYMBOL} tokens. All transactions through the Smart Contract require your confirmation ("Confirm" or "Sign") in the MetaMask app. You and your partners may select one of the test networks to practice, by expanding the default network displayed on the upper-right corner of the MetaMask and enabling "Show/hide test networks". We suggest ${TESTNET_NAME} for testing. Go to ${FAUCET_URL} to request for test coins. `
                    },
                    button: {
                        read: {
                            title: "Read Tutorial",
                        },
                        install: {
                            title: 'Install MetaMask',
                            confirm: {
                                title: 'Install MetaMask',
                                content: 'Please refresh this webpage to proceed to the next step after MetaMask installation',
                                button: 'Install MetaMask'
                            }
                        }
                    }
                },
                confirm: {
                    checkbox: {
                        title: 'I\'m about to pause and switch to an external application temporarily. I can come back to resume this configuration process.'
                    },
                    cancel: 'Cancel'
                },
                tutorial: {
                    slide1: {
                        title: 'PlexiMail',
                        subtitle: 'A Web3 Secure eMail dApp',
                        content: {
                            paragraph1_1: 'PlexiMail is a Web3 dApp (decentralized App). This is only one of the Web3 applications we offer. Please visit ',
                            paragraph1_2: ' for our Counterseal mobile app, or ',
                            paragraph1_3: ' for the general background about us.',
                            paragraph2: 'A longer and more detailed write-up can be found by clicking on the "?" box in the lower right-hand corner of the screen.'
                        },
                        button: {

                        }
                    },
                    slide2: {
                        title: `If you are not paying, you're the product.`,
                        content: {
                            paragraph1: 'Web2 refers to the version of the Internet most of us know today, dominated by companies that provide services for free in exchange for our personal data. The terms of the exchange are typically shrouded in arcane language to satisfy the minimal legal requirements. Our personal data are collected through sophisticated surveillance technology that knows no bounds and leaves no trace. All popular free services, such as Facebook, Twitter, Google, Outlook, WeChat, Telegram, etc. are top  examples of Web2 applications deeply rooted in Surveillance Capitalism. It is a “cattle farm” model designed for smooth onboarding and subsequent exploitation of the unsuspecting. We are being unwittingly turned into products right before our eyes.'
                        },
                        button: {

                        }

                    },
                    slide3: {
                        title: 'Surveillance Capitalism',
                        content: {
                            paragraph1: 'Web3 grows out of the chilling realization of our being herded around like cattles for the financial gains of those Web2 big techs. No amount of privacy regulations will save us from their predatory practices. There is no alternative but to revolt against this repressing “cattle farm” environment underlying the Internet at large. We need a fresh start. This is how the Web3 framework came about, fueled by Blockchain technology and tokenized cloud storage. '
                        },
                        button: {

                        }

                    },
                    slide4: {
                        title: 'No More Free Feeds',
                        content: {
                            paragraph1: 'One thing for certain, to “live dangerously” and independently off the grid of Web2 implies that individuals must get more involved. At minimum, we have to correct our distorted concept of privacy and security purportedly offered by service providers, which requires us to educate ourselves what the security protection is truly about. We are then confronted with the resource issues - How and where can we get our data storage, processing power and service platforms? It turns out that help is actually around the corner.'
                        },
                        button: {

                        }

                    },
                    slide5: {
                        title: 'Self Sufficiency Under Web3',
                        content: {
                            table: (<Table>
                                <Thead>
                                  <Tr>
                                    <Th></Th>
                                    <Th>Web 2.0</Th>
                                    <Th>Web 3.0</Th>
                                  </Tr>
                                </Thead>
                                <Tbody fontSize={{ base: 'sm', lg: 'sm' }}>
                    
                                  <Tr>
                                    <Td>Identity</Td>
                                    <Td>Service Account: primarily to protect the provider and link to user PII for subject triangulation.</Td>
                                    <Td><Text as="span" style={{fontWeight: 'bold', color: 'red'}}>Subject identified by cryptographic key pairs self-managed through wallet like MetaMask.</Text></Td>
                                  </Tr>
                                  <Tr>
                                    <Td>Resources</Td>
                                    <Td>Data Center storage, servers, service bandwidth.</Td>
                                    <Td><Text as="span" style={{fontWeight: 'bold', color: 'red'}}>Privately provided or through Web3 services like Web3Storage.</Text></Td>
                                  </Tr>
                                  <Tr>
                                    <Td>Transparency</Td>
                                    <Td>Not offered, suspected of containing large amount of surveillance logic; Who watches the watchers?</Td>
                                    <Td>Open-sourced security and transparency published as tokenized Smart Contract on Blockchain.</Td>
                                  </Tr>
                                </Tbody>
                              </Table>),
                            paragraph1: `Weaned off those free services, the items in red above become your responsibility. You must create and protect your digital identities in order to enter the Smart Contract on the ${BLOCKCHAIN_NAME_CAMEL} blockchain. Your IDs are derived from your blockchain addresses in your <strong>MetaMask Wallet</strong>, further protected by a password as the second factor of security. You own your private cloud storage allocated to you by <strong>Web3Storage</strong>, a tokenized storage service offered by Filecoin.`
                        },
                        button: {

                        }

                    },
                    slide6: {
                        title: 'ePostcard and Metadata',
                        content: {
                            paragraph1: 'Under Web3, you are in charge of your own identity. This is important, because traditional emails are like ePostcards, where the identities of all parties are out in the open. This is problematic, particularly because email communications often involve sensitive, private matters. Further, metadata in your emails expose you to exploitation by dark actors.'
                        },
                        button: {

                        }

                    },
                    slide7: {
                        title: 'Anonymity and Privacy',
                        content: {
                            paragraph1: `PlexiMail translates your ${BLOCKCHAIN_NAME_CAMEL} addresses into PlexiMail addresses with "${mailAddressSuffix()}" as the domain name, protected by their private keys securely stored in the <strong>MetaMask Wallet</strong> held only by the owner that they represent. The identities of sender/recipients are thus anonymized and not relatable to any PII (Personally Identifiable Information). Functionally, they are secured by self-issued/managed digital assets (key pair in the wallet) like SSL certificates. These somewhat unwieldy PlexiMail addresses can be better managed by adding them to your existing or new ‘Contacts’. Note that those "Contacts" are maintained locally in the owner's environment and not copied into the mail content.`,
                            paragraph2: 'NOTE: Even the wallet addresses can be anonymized. We will be offering such a service.'
                        },
                        button: {

                        }

                    },
                    slide8: {
                        title: 'Guaranteed Anonymity',
                        content: {
                            paragraph1: 'This is how an end-to-end encrypted session is established by traversing the PlexiMail <strong>Smart Contract</strong>, trust-minimized <strong>Registry & Notification Forwarder</strong> and individualized <strong>cloud Web3Storage</strong>. The gory details are on the next page.'
                        },
                        button: {

                        }

                    },
                    slide9: {
                        title: 'Guaranteed Anonymity',
                        content: {
                            paragraph1: `1. Alice and Bob both register their addresses from their wallets and server selection from multiple candidate servers,  through PlexiMail smart contract on ${BLOCKCHAIN_NAME_CAMEL} blockchain.`,
                            paragraph2: '2. Alice selects and preps the pre-key store onto the selected registry server.',
                            paragraph3: '3. Alice/Bob privately exchange their PlexiMail addresses “out of band” in preparation for the person-to-person TOFU (Trust On First Use) process later, which ties their identities with their respective stealth addresses.',
                            paragraph4: `4. Prior to Bob’s sending a Mail to Alice for the first time, he retrieves all relevant data regarding Alice from the ${BLOCKCHAIN_NAME_CAMEL} data store and the Registry. He then asynchronously negotiates an end-to-end Signal encryption session with Alice, who need not to be online.`,
                            paragraph5: '5. Bob places his mail content in his own private Web3Storage and pushes his notification to Alice, with the decryption key authorized only to Alice.',
                            paragraph6: '6. On notice, Alice retrieves the content from Bob’s private storage. She decrypts the content only after verifying the various TOFU parameters.',
                        },
                        button: {

                        }

                    },
                    slide10: {
                        title: 'Running Cost',
                        subtitle: 'A Web3 Secure Email Service',
                        content: {
                            paragraph1: `PlexiMail is a free application, but its operating consumables, like electricity, computing power, traditional disk storage, RAM, printer, ink, Internet connectivity, etc., are not. As a Web3 dApp running on ${BLOCKCHAIN_NAME_CAMEL}, it consumes “${BLOCKCHAIN_NAME_CAMEL} gas”, which is the charge by the ${BLOCKCHAIN_NAME_CAMEL} blockchain for your consumption of its computational resources. The initial setup costs gas and an extremely nominal charge of $.0001 per sent email is assessed to thwart DDOS. Note that there is no additional charge for oversized content (e.g., emails and attachments as large as 1 GB).`
                        },
                        button: {

                        }

                    },
                    slide11: {
                        title: 'Get Your Own Wallet & Web3Storage',
                        content: {
                            paragraph1: 'We hope you now have a better understanding of the PlexiMail framework. To obtain PlexiMail ++, please install MetaMask and apply for the Web3 cloud storage from the Web3storage site, as prompted in the following pages. '
                        },
                        button: {

                        }

                    },
                    slide12: {
                        title: '',
                        content: {
                            paragraph1: `PlexiMail utilizes your own private Web3.Storage for your email repository. In the past, storing data on the decentralized web wasn't always easy — but that's where web3.storage comes in. Most data on the Internet today is hosted by massive storage providers like Amazon, Google, and Microsoft. This makes it simpler for developers to store application data, but big corporate platforms like these create silos by locking developers and users alike into walled gardens of services. What's more, as the market continues to consolidate, a small oligopoly of providers are essentially becoming the storage backbone of the internet. `,
                            paragraph2: 'Get yourself first 5 GB for free by clicking the "Get" button blow. Extract the "Account" -> "<strong>API Token</strong>" from your Web3Storage dashboard when done and get back here to prepare for the PlexiMail configuration later.'
                        },
                        button: {
                            get: {
                                title: 'Get Web3.Storage',
                                confirm: {
                                    title: 'Get Web3.Storage',
                                    content: 'Please return here after successfully acquiring your private Web3.Storage.',
                                    button: 'Get Web3.Storage'
                                }
                            }
                        }

                    },
                    slide13: {
                        title: '',
                        content: {
                            paragraph1_1: `In order to use PlexiMail, you need to establish at least one digital identity, and carry out a trustless signup through our ${BLOCKCHAIN_NAME_CAMEL} smart contract, which requires you to install the MetaMask wallet extension through your browser. Follow our`,
                            paragraph1_2: ` to learn more about the various ${BLOCKCHAIN_NAME_CAMEL} network options and how to fund your wallet (faucets). If you want to practice with a test network, expand the default network displayed on the upper-right corner of MetaMask and enable "Show/hide test networks". We suggest ${DEFAULT_NET_NAME} for testing. Go to ${FAUCET_URL} to request for test coins. Please click on the "Install MetaMask" box blow to install MetaMask. `,
                        },
                        button: {
                            install: {
                                title: 'Install MetaMask',
                                confirm: {
                                    title: 'Install MetaMask',
                                    content: 'Please return here after MetaMask installation.',
                                    button: 'Install MetaMask'
                                }
                            }
                        }

                    },
                    slide14: {
                        title: 'Congratulations',
                        content: {
                            paragraph1: 'If the MetaMask has been installed and the Web3Storage acquired successfully, you are now ready to use PlexiMail. Please click on the green box below to configure PlexiMail. '
                        },
                        button: {
                            config: {
                                title: 'Configure PlexiMail'
                            }
                            
                        }

                    }
                }
            }
        },
        setup_method: {
            title: 'Resume or Start Over a Configuration',
            content: {
                paragraph1: 'Select “Resume” to pick up the same configuration or "Start Over" to create a brand new configuration for the same wallet. ',
                paragraph2: 'Please make sure you understand that pressing the “Start Over” button would erase all your past emails.'
            },
            button: {
                create: {
                    title: 'Start Over'
                },
                restore: {
                    title: 'Resume'
                },
                back: {
                    title: "Back"
                }
            }
        },
        backup_method: {
            // step: '1 / 4: ',
            title: 'Back up Recovery Data',
            content: {
                paragraph1: 'Your PlexiMail data are backed up by storing their root creation/recovery seeds, based on which all earlier session data and contents may be recovered from your previous backup.',
                paragraph2: 'The backup data are fully encrypted, and are further protected by employing our Crypton technologies (patent pending).',
                paragraph3: 'The password must be of sufficient strength to be accepted. A sentence-like passphrase works nicely.',
                paragraph4: 'Steps remaining: 4/4    '
            },
            button: {
                web3: {
                    title: "Store into Your Web3Storage"
                },
                local: {
                    title: 'Store Locally'
                },
                back: {
                    title: "Back"
                }
            }
        },
        restore_method: {
            // step: '1 / 4: ',
            title: 'Retrieve Recovery Data',
            content: {
                paragraph1: 'Your PlexiMail data are backed up by storing their root creation/recovery seeds, based on which all previous session data and contents may be recovered from your permanent Web3Storage.',
                paragraph2: 'Steps remaining: 3.'
            },
            button: {
                web3: {
                    title: "Retrieve from Web3.Storage"
                },
                local: {
                    title: 'Retrieve from Local File'
                },
                back: {
                    title: "Back"
                }
            }
        },
        pwd: {
            override: {
                title: 'Warning',
                message: 'This Crypton already exists. Do you want to overwrite it?',
                button: {
                    yes: 'Yes',
                    no: 'No'
                }
            },
            initial: {
                step: '1 / 4: ',
                step_restore: '1 / 3',
                title: 'Protecting Your Configuration Database',
                recover_title: 'Unlock Your Configuration Database',
                content: {
                    paragraph1_1: 'This password is to protect your PlexiMail configuration and the full session context required for assuming your PlexiMail identity in managing all your emails. Make sure you record: 1) email used with Magic.Link 2) email used with Web3.Storage 3) this password. They are critically important for the PlexiMail backup and recovery.',
                    paragraph1_2: 'Please enter the protection password.',
                    paragraph2: 'The password must be of sufficient strength to be accepted. A long enough sentence-like passphrase works well.',
                    // input: 'Please enter the protection password.'

                },
                tf: {
                    pwd: {
                        title: 'Password'
                    },
                    confirm: {
                        title: 'Confirm Password'
                    }
                },
                button: {
                    next: {
                        title: 'Next'
                    },
                    back: {
                        title: "Back"
                    }
                }

            }
        },
        mnemonic: {
            generate: {
                step: '2 / 4: ',
                title: 'Construct the Protection Chain',
                content: {
                    paragraph1: <Text color={'gray.500'} fontSize={{ base: 'sm', sm: 'md' }}>Accepting the password for configuration database, which in turn generates a tree of additional protection keys.<TutorialModalLink title={"  Learn more"} /></Text>,
                    paragraph2: <Text color={'gray.500'} fontSize={{ base: 'sm', sm: 'md' }}></Text>,
                    // paragraph3: 'Click the mnemonic content above to copy to your clipboard.',
                },
                message: {
                    copied: 'Copied',
                },
                button: {
                    display: {title: 'Generate Mnemonic'},
                    hide: {title: 'Hide Mnemonic'},
                    next: {title: 'Next'},
                    gen: {title: 'Generate'},
                    // gen_save: {title: 'Generate and Save Locally'},
                    gen_save: {title: 'Generate'},
                    back: {title: 'Back'}
                }
            },
            restore: {
                step: '2 / 3: ',
                title: 'Restore the Protection Chain',
                content: {
                    paragraph1: <Text color={'gray.500'} fontSize={{ base: 'sm', sm: 'md' }}>Applying the protection password for the recovery seeds and the tree of additional protection keys. <TutorialModalLink title={"Learn more"} /></Text>,
                    paragraph2: <Text color={'gray.500'} fontSize={{ base: 'sm', sm: 'md' }}></Text>,
                    paragraph3: 'Click the mnemonic content above to copy to your clipboard.'
                },
                mnemonic: {
                    label: 'Mnemonic Phrase',
                    placeholder: 'Mnemonic Phrase for Recovery'
                },
                button: {
                    next: {title: 'Next'},
                    web3: {title: 'Restore from Web3.Storage'},
                    local: {title: 'Restore from Local File'},
                    back: {title: 'Back'}
                }
            }

        },
        web3: {
            selector: {
                step: '4 / 6: ',
                title: 'Configure Your Own Private Web3 Storage',
                content: {
                    paragraph1: 'This is the second step for creating a new configuration unless you want to restore a prior one.',
                    paragraph2_1: 'Your PlexiMail is kept in your own private storage, provided by Filecoin, without involving any 3rd-party service providers. This is critical to achieve total control of your data and, equally critical, your metadata. Get your first 5GB storage by visiting ',
                    paragraph2_2: ' https://web3.storage/account/ ',
                    paragraph2_3: ', which is currently free. After finishing the Web3 account set-up, click the “Account” button on the upper right of the web3.storage page and select the “API Tokens” to copy the long token string. Select “Config Web3 Storage” button here in order to pass on the API Token and paste to PlexiMail. '
                },
                button: {
                    config: {title: 'Create New Configuration with Allocated Web3.Storage'},
                    import: {title: 'Restore Prior Configuration Settings'},
                    back: {title: 'Back'}
                }
            },
            new_selector: {
                title: 'Configure Your Private Web3 Storage',
                content: <><Text color={'gray.500'} fontSize={{ base: 'sm', sm: 'md' }}>
                Great job on successfully creating your PlexiMail address protected by your Ai-Fi wallet! Now it's time to acquire and configure your own private email repository without relying on any email providers. In the past, storing data on the decentralized web wasn't always easy — but that's where web3.storage comes in.
                </Text>
                <Text mt={"20px"} color={'gray.500'} fontSize={{ base: 'sm', sm: 'md' }}>
                There are two ways to acquire your web3.storage, namely the established <strong>"API Token"</strong> approach and the newer and easier <strong>"W3:UI"</strong> option.
                The "API Token" interface has been stable and reliable, but takes a few more steps to set up. On the other hand, "W3:UI" is more streamlined and simpler, but <strong>it is currently in BETA and not working on iPhone</strong>.
                We encourage you to start with the "API Token" configuration. Switch to "W3:UI" only if you encounter difficulties and wish to continue as a preview run. <TutorialModalLink title={"Learn more"} anchor={"private-web3-storage"} />
                </Text></>,
                api_token: 'API Token',
                w3ui: 'W3:UI (w3up)',
                safari: 'Currently the W3:UI option is not supported on Safari browser.',
                normal: 'Currently the W3:UI option is not supported on this browser',
                mainnet: `Currently PlexiMail does not support the W3:UI option when used with the ${BLOCKCHAIN_NAME_CAMEL} ${MAINNET_NAME}.`,
            },
            storage_selector: {
                title: 'Configure Your Private Web3 Storage',
                recover_title: 'Recover Your Private Web3 Storage',
                content: <><Text color={'gray.500'} fontSize={{ base: 'sm', sm: 'md' }}>
                Now, take control of your email privacy. Set up your own private email repository, free from any surveillance risks associated with some email providers.
                </Text>
                <Text mt={"20px"} color={'gray.500'} fontSize={{ base: 'sm', sm: 'md' }}>
                In the past, privately managing your own data on the decentralized web was challenging. However, Filecoin has emerged as a solution, allowing for a variety of front-end services. These services each support specific application models and offer subscription options. We currently offer two of these services:<br />
                    <br />
                    <strong>LightHouse (<a rel="noreferrer" href="https://lighthouse.storage" target="_blank">https://lighthouse.storage</a>)</strong>: Offers 1GB of free storage as a starter plan, without requiring credit card information.<br />
                    <strong>Web3Storage (<a rel="noreferrer" href="https://web3.storage" target="_blank">https://web3.storage</a>)</strong>: Offers 5GB of free storage as a starter plan, but <strong><i>requires credit</i></strong> card information to subscribe. This service also uses public emails for user authentication.<br />
                    <br />
                    Visit their websites to compare options and choose the best provider for your needs. Be aware that additional charges apply after exceeding the free storage limit. Setting up Lighthouse requires credit card information only if you choose to exceed the free tier.
                </Text></>,
                lighthouse: 'Lighthouse',
                web3storage: 'Web3.Storage',
                sharedWeb3storage: 'Shared Web3.Storage',
                back: 'Back'
            },
            lighthouse: {
                step: '1 / 2:',
                title: 'Configure Your Private Lighthouse Storage',
                content: <Text color={'gray.500'} fontSize={{ base: 'sm', sm: 'md' }}>
                Please confirm your selection of the free Lighthouse storage plan! This storage is uniquely and anonymously linked to your PlexiMail wallet. You'll only need to provide payment information if you choose to upgrade beyond the free tier.
                </Text>,
                auth: 'Contacting Lighthouse...',
                import: {
                    title: '',
                    message: {
                        ready: '',
                        recover_web3: 'Recovering Lighthouse Storage config...',
                        retrieve_folder: 'Retrieving mails from Lighthouse Storage...',
                        recover_signal: 'Recovering signal protocol storage...',
                        completed: 'Completed!'
                    },
                    content: {
                        paragraph1: 'Please select a config file',
                    },
                    button: {
                        import: {title: 'Import from saved file'},
                        import_phone: {title: 'Import from Your Phone'},
                        back: {title: 'Back'}
                    }
                }
            },
            w3ui: {
                step: '1 / 2:',
                title: 'Configure Your Private Web3 Storage',
                content: <Text color={'gray.500'} fontSize={{ base: 'sm', sm: 'md' }}>
                Great job on successfully creating your PlexiMail address protected by your Ai-Fi wallet! Now it's time to acquire and configure your own private email repository without relying on any email providers. In the past, storing data on the decentralized web wasn't always easy — but that's where web3.storage comes in.
                </Text>,
                note: 'A confirmation email will be sent to this mailbox for validation. Take a momentary break here and switch to your email client to respond to the verification email by clicking \'Verify email address\', sent by web3.storage. If prompted, you can sign up with a credit card, but feel free to choose the Free option initially. Web3.Storage is the most established Web3 storage provider with minimal risk to your credit card. After verification, continue with the configuration process.',
                verify: {
                    title: 'Verifying your email address...',
                    message_1: 'Please take a momentary break here and switch to your email client at',
                    message_2: 'to respond to the verification email in order to sign in.',
                    message_3: 'You can request a resend in',
                    message_4: 'seconds.',
                    message_5: 'RESEND',
                    message_6: 'if not succeeding.'
                },
                shared: {
                    config_storage: 'Configuring storage ...'
                }
            },
            config: {
                step: '3 / 4: ',
                step_restore: 'Final: ',
                title: 'Your Storage, Your Rules',
                recover_title: 'Recover Web3 Storage',
                content: {
                    paragraph1_1: 'Visit', 
                    paragraph1_2: ' to acquire your private Web3 storage. After finishing the Web3 account set-up, click the “Account” button on the upper right of the web3.storage page and select the “API Tokens” to copy the long token string. ',
                    paragraph1_3: 'The “API Token” of your Web3Storage has been auto-filled with retrieved data from your Configuration database. There is a small chance that it might have been invalidated by your Web3 storage provider. If the “Next” button below returns an error, please go back and get a new token by recovering your Web3 account.  (Click the “Account” button on the upper right of the web3.storage account page and select the “API Tokens” to copy the long token string.)',
                    paragraph2: 'Paste your Web3 Storage token here in order for PlexiMail to locate your private storage.',
                    tokenTextField: {placeholder: 'Enter Web3 Storage API Token here'},
                    paragraph3: 'All your PlexiMail data are stored in your own private storage space acquired from Web3Storage. Although it is in plain sight, it is virtually anonymous and fully encrypted through dynamic keys from your own wallet with strength equivalent to any public blockchain transaction keys. ',
                    invalid_token: 'Incorrect API Token format. Verify and ensure the complete string is copied.',
                    as_default: 'As Default Storage'
                },
                button: {
                    next: {title: 'NEXT'},
                    back: {title: 'Back'}
                }
            },
            import: {
                title: '',
                message: {
                    ready: '',
                    recover_web3: 'Recovering Web3.Storage config...',
                    retrieve_folder: 'Retrieving mails from Web3.Storage...',
                    recover_signal: 'Recovering signal protocol storage...',
                    completed: 'Completed!'
                },
                content: {
                    paragraph1: 'Please select a config file',
                },
                button: {
                    import: {title: 'Import from saved file'},
                    import_phone: {title: 'Import from Your Phone'},
                    back: {title: 'Back'}
                }
            },
            mnemonic_recover: {
                title: 'Recover Wallet from Mnemonic Phrase',
                token: {
                    label: 'Web3.Storage API Token',
                    placeholder: 'Web3 Storage API Token'
                },
                mnemonic: {
                    label: 'Mnemonic Phrase',
                    placeholder: 'Mnemonic Phrase for Recovery'
                },
                button: {
                    close: {title: 'Close'},
                    recover: {title: 'Recover'},
                },
                trigger: {title: 'Recovery from Mnemonic'}
            }
        },
        signal: {
            initial: {
                step: 'Final: ',
                title: 'Prepare Signal Runtime',
                content: {
                    paragraph1: 'Hurray on setting up your web3 storage successfully! We adopt the Signal Protocol to protect your end-to-end communication sessions. Your PlexiMail addresses are bound to the private keys in your wallet at this step, which spawns a full spectrum of session keys and other security parameters as per situations.',
                    paragraph2: `Please prepare to allow the signing of confirmation transaction with keys from your ${BLOCKCHAIN_NAME_CAMEL} wallet (if requested).`,
                    paragraph3: 'Learn more about Open Whisper Systems and Signal Protocol.'
                },
                button: {
                    next: {title: 'PROCEED'},
                    back: {title: 'Back'}
                }
            }
        },
        export: {
            default: {
                step: 'Step 7: ',
                title: 'Backup PlexiMail Configuration',
                content: {
                    paragraph1: 'Your PlexiMail session configuration and key generating materials are kept in your browser as “Cookies and other site data” under the “Privacy and security” settings, which may get cleared accidentally. For ease of recovery, this configuration data may be backed-up/exported here to recover your established sessions. Note that your identity or PlexiMail address is separately guarded through a more stringent passphrase mechanism. ',
                },
                button: {
                    export: {title: 'EXPORT CONFIGS'},
                    back: {title: 'Back'}
                }
            }
        },
        wait: {
            default: {
                // step: 'Wrap Up: ',
                title: 'Waiting for transaction receipt...',
                content: {
                    paragraph1: `Your PlexiMail address and session data are safeguarded on the ${BLOCKCHAIN_NAME_CAMEL} Blockchain through a Smart Contract. Please wait until this process completes.`,
                    paragraph2: 'Checking transaction receipt... ',
                    paragraph3: 'Failed to get the transaction receipt. Please try again later.',
                    paragraph4: 'Transaction has been confirmed, Automatically enter PlexiMail in 10 seconds... ',
                },
                button: {
                    enter: {title: 'Enter into PlexiMail'},
                    retry: {title: 'Retry'},
                    back: {title: 'Back'}
                }
            }
        },
        on_click_create: {
            
            title: '1-Click Create',
            loading: 'Newly created account is initializing',
            description: 'Most of the time when users restore PlexiMail, they will still use the previous configuration. Following the normal recovery process steps is very cumbersome. 1-Click resume provides a shortcut for this scenario.',
            note: '* If the Privacy Level is inconsistent with the current running platform, it will be modified to suit the new environment.',
            button: {
                back: 'Back',
                retry: 'Retry',
            }
        },
        one_click_resume: {
            title: '1-Click Resume',
            description: 'Most of the time when users restore PlexiMail, they will still use the previous configuration. Following the normal recovery process steps is very cumbersome. 1-Click resume provides a shortcut for this scenario.',
            note: '* If the Privacy Level is inconsistent with the current running platform, it will be modified to suit the new environment.',
            button: {
                back: 'Back',
                retry: 'Retry',
            }
        },
        one_click_create: {
            title: '1-Click Create',
        },
        main: {
            title: 'PlexiMail',
            sidebar: {
                create: 'Create Folder'
            },
            menu: {
                account_section: 'My Account',
                global_section: 'Global',
                operations_section: 'Operations',
                wallet: 'Wallet',
                settings: 'Settings',
                help: 'Help',
                buy_eth: 'Buy Eth',
                profile: 'Addresses',
                contacts: 'Contacts',
                more: 'Advanced',
                tutorial: 'Tutorial',
                sign_out: 'Exit',
                switch_account: 'Switch Account'
            },
            dialog: {
                pwa: {
                    title: 'PlexiMail can run as a standalone web application',
                    content: {
                        paragraph1: 'Instead of running in a Browser tab, PlexiMail can be packaged to run in a standalone window, independently searchable and launchable through its dedicated application icon on the desktop almost like a native app. '
                    },
                    button: {
                        cancel: 'Skip',
                        install: 'Install PlexiMail'
                    }
                },
                create_folder: {
                    title: 'Create Folder',
                    content: {
                        name: 'Name: ',
                        parent: 'Under: '
                    },
                    button: {
                        cancel: 'Cancel',
                        save: 'Save'
                    },
                    message: {
                        character_is_not_allowed: ' is not allowed'
                    }

                },
                sign_out: {
                    title: 'Are you sure you want to exit PlexiMail?',
                    content: {
                        paragraph1: 'All your cached session context will be cleared after signing out!',
                        paragraph2: 'To reconnect to current PlexiMail session, choose the "Recover" and then "Resume" option on reentry.'
                    },
                    button: {
                        cancel: 'Cancel',
                        sign_out: 'Exit'
                    }
                }
            }
        },
        list: {
            welcome: {
                // title: 'Welcome to PlexiMail',
                title: 'No Messages',
                sub_title: 'Close the Loop with PlexiMail Pro',
                description: 'Despite the rise in instant messaging, SMS, and social networking, email remains the predominant business collaboration tool. Unfortunately, the unsecured nature of email exposes sensitive information to malicious attacks. Distinguish your brand by halting the seemingly unstoppable phishing pandemic from eroding your reputation. Cultivate trust with your customers and ensure compliance with privacy regulations using PlexiMail Pro.',
                action: ' Learn More'
            }
        },
        previewer: {
            menu: {
                back: 'Back',
                reply: 'Reply',
                reply_all: 'Reply All',
                forward: 'Forward',
                move: 'Move',
                delete: 'Delete',
                reload: 'Reload'
            },
            message: {
                attachment: {
                    title: 'Attachments',
                    download: {
                        downloading: 'Downloading, please wait',
                        is_in_progress: 'Download in progress',
                        progress: {
                            paragraph1_1: 'Downloaded ',
                            paragraph1_2: ' of ',
                            paragraph2: 'Downloaded'
                        },
                    }
                },
                failed_to_load: 'Failed to load message',
                select_folder: 'Please select a folder to move',
                moved: 'Moved',
                moved_to_trash: 'Message moved to Trash',
                deleted: 'Deleted',
                tofu_changed: 'The signature of the sender has changed since the last time you two corresponded. You might want to re-authenticate the sender (through a different channel). Press "Trust & Decrypt" only if nothing is amiss.',
                tofu_new: 'This is the first time getting PlexiMail from this sender. You might want to double-check the authenticity of the sender (through a different channel). Press "Trust & Decrypt" only if nothing is amiss.'
            },
            tofu: {
                // verify: <Text fontSize={"sm"} mt={4} align="left" width="100%">PlexiMail adopts the same signature scheme as {BLOCKCHAIN_NAME_CAMEL} and relies on its Smart Contract to authenticate registered users and to support online auditability. For unregistered or "Verified by ICP" users with a orange warning sign: "<GoUnverified size={16} color="orange" align={"middle"} style={{display: 'inline', verticalAlign: 'middle'}} />", you may want to <Link href="https://ai-fi.cc/help.html#double-check-the-tofu-signature-personally" target="_blank" color="#00aaff">double-check the TOFU signature personally</Link>, even when it is labeled as "CORRECT", based on the public {BLOCKCHAIN_NAME_CAMEL} Signature standard.</Text>,
                verify: <Text fontSize={"sm"} mt={4} align="left" width="100%">PlexiMail adopts the same signature scheme as {BLOCKCHAIN_NAME_CAMEL} and relies on its Smart Contract to authenticate registered users and to support online auditability.</Text>,
                steps: <>
                    <OrderedList mt={4} fontSize={"sm"} px={10}>
                    <ListItem>go to <Link href="https://etherscan.io/verifiedSignatures" target="_blank" color="#00aaff">https://etherscan.io/verifiedSignatures</Link> and Click <Badge>Verify Signature</Badge>.</ListItem>
                    <ListItem>On the Etherscan Verify Signature pop-up, fill the data fields <Badge>Address</Badge>, <Badge>Message</Badge>, and <Badge>Signature Hash</Badge>with <Badge>Sender</Badge> address, <Badge>Identity Key</Badge>, <Badge>Signature</Badge> respectively from below. Data displayed below are all clickable for copy and paste.</ListItem>
                
                </OrderedList>
                    <Text mt={3} fontSize={"sm"} fontWeight={"bold"}></Text></>,
                sender: 'Sender',
                idkey: 'Identity Key',
                signature: 'Signature',
                address: 'Address',
                copied: 'Copied',
                verified: '',
                miss: <Badge variant='solid' colorScheme='red'>Missing</Badge>,
                correct: <Badge variant='solid' colorScheme='green'>Correct</Badge>,
                incorrect: <Badge variant='solid' colorScheme='red'>Incorrect</Badge>
            },
            dialog: {
                add_contact: {
                    title: 'Add Contact',
                    content: {
                        name: 'Name: ',
                        email: 'PlexiMail Address: '
                    },
                    button: {
                        cancel: 'Cancel',
                        add: 'Add'
                    }
                },
                move_message: {
                    title: 'Move Message',
                    button: {
                        cancel: 'Cancel',
                        move: 'Move'
                    }
                },
                cid_not_found: {
                    title: 'Failed to download',
                    message: 'Due to the high volume of PlexiMail traffic, your download request couldn\'t be met right now. You can opt for continuous retries until completion, or come back later to check again. Please be patient, as the wait time is difficult to predict. 10 ~ 20 min is not unusual. The world record is about 3 hours.'
                }
            }
        },
        editor: {
            title: {
                new_message: 'New Message',
                reply: 'Reply',
                reply_all: 'Reply All',
                forward: 'Forward'
            },

            content: {
                pwd: {
                    passcode: 'Passcode',
                    title: 'Please enter a passcode for encrypting this message',
                    description: 'Password required to send encrypted emails to non-PlexiMail recipients.',
                    allow_reply: 'Allow recipient to reply',
                    allow_reply_explain: ' (Reply is allowed only if there is a single recipient)',
                    assist_account_creation: 'Assisting the recipient with a streamlined PlexiMail signup script.',
                    cancel: 'Cancel',
                    next: 'Next'
                },
                tofu: {
                    message: 'This is the first time sending PlexiMail to the recipient(s) listed at the end. You might want to double-check their authenticity (through a different channel).',
                    verify: <Text fontSize={"sm"}>PlexiMail adopts the same signature scheme as {BLOCKCHAIN_NAME_CAMEL} and relies on its Smart Contract to authenticate registered users and to support online auditability.</Text>,
                    steps: <>
                        <OrderedList fontSize={"sm"} px={3}>
                        <ListItem>go to <Link href="https://etherscan.io/verifiedSignatures" target="_blank" color="#00aaff">https://etherscan.io/verifiedSignatures</Link> and click <Badge variant='solid'>Verify Signature</Badge>.</ListItem>
                        <ListItem>On the Etherscan Verify Signature pop-up, fill the data fields<Badge variant='solid'>Address</Badge>,<Badge variant='solid'>Message</Badge>, and<Badge variant='solid'>Signature Hash</Badge>with PlexiMail<Badge variant='solid'>Address</Badge>,<Badge variant='solid'>Identity Key</Badge>,<Badge variant='solid'>Signature</Badge> respectively from below. Data displayed below are all clickable for copy and paste.</ListItem>
                    
                    </OrderedList>
                        <Text mt={3} fontSize={"sm"} fontWeight={"bold"}></Text></>,
                    title: 'Untrusted Recipient(s)',
                    idkey: 'Identity Key',
                    signature: 'Signature',
                    address: 'Address',
                    copied: 'Copied',
                    miss: <Badge variant='solid' colorScheme='red'>Missing</Badge>,
                    correct: <Badge variant='solid' colorScheme='green'>Correct</Badge>,
                    incorrect: <Badge variant='solid' colorScheme='red'>Incorrect</Badge>,
                },
                editor: {
                    from: {
                        title: 'From: ',
                    },
                    to: {
                        title: 'To: ',
                        placeholder: `e.g. 0x0...000${mailAddressSuffix()} or name from Contacts (Required)`,
                        placeholder_more: 'Enter more recipients here',
                        show_contact: 'Select Recipient(s)'
                    },
                    subject: {
                        title: 'Subject: ',
                        placeholder: ''
                    },
                    content: {
                        initial_content: 'Sent by PlexiMail'
                    },
                    attachment: {
                        title: 'Attachments'
                    }
                },
                contacts: {
                    title: 'Select Recipient(s)',
                    content: {
                        search: 'Search...',
                        empty: 'No contacts'
                    },
                    button: {
                        confirm: 'Confirm'
                    }
                }
            },
            message: {
                upload: {
                    paragraph1_1: 'Uploading... (',
                    paragraph1_2: ' uploaded)',
                    paragraph1_3: 'Uploading...',
                    paragraph1_4: 'Uploaded ',
                    paragraph1_5: ' of ',
                    encrypting: 'Encrypting...',
                },
                address: {
                    invalid_addr_1: 'The above address',
                    invalid_addr_2: 'was not recognized. Please ensure that all addresses are in the correct format.',
                    invalid_eth: 'Cannot send email to traditional mailboxes and PlexiMail mailboxes at the same time.',
                    invalid_normal: 'Cannot send email to traditional mailboxes and PlexiMail mailboxes at the same time.',
                    multi_recps: 'Cannot send email to multiple traditional mailboxes at once.'
                },
                sent: 'Message is sent!',
                // restriction: 'Attachments are not allowed, plus many other restrictions.'
                restriction: 'The bridging function is one-way and accepts no replies. '
            },
            button: {
                add_attachment: {
                    title: '',
                    tips: 'Add Attachment(s)'
                },
                send: {
                    send: 'Send',
                    trust_and_send: 'Trust & Send'
                }
            },
            unverified: {
                title: 'Warning',
                description_1: 'Your PlexiMail Address is currently in the "Verified by ICP" status, placing an additional burden on your partners to authenticate you without the advantages provided by registering with the PlexiMail Smart Contract.',
                description_2: 'To upgrade this status, simply click on the "Verified by ICP" status display located on the upper left of the main screen and follow the instructions provided. Alternatively, you can upgrade your status from within the "Settings".',
                description_3: '',
                dont_show_again: 'Don\'t show this message again',
                next: 'Next'
            },
            save_draft: {
                title: 'Save Draft',
                description: 'We have detected an unsent draft in the buffer. Would you like to save it?',
                discard: 'Discard',
                save: 'Save'
            },
            load_draft: {
                title: 'Load Draft',
                description: 'There is a draft copy saved previously.',
                discard: 'Discard',
                recover: 'Recover'
            }
        },
        settings: {
            account_title: 'Advanced',
            title: 'Settings',
            message: {
                cache_cleard: 'Cached Data was cleared'
            },
            list: {
                export: {
                    title: 'Export Configuration Settings',
                    description: 'Configuration Settings will help recover your PlexiMails after any loss event.'
                },
                mnemonic: {
                    title: 'Show Mnemonic Phrase',
                    description: 'Display Seed Phrase for recovering all encryption key materials.'
                },
                privateKeys: {
                    title: 'Show Lighthouse Accounts',
                    description: 'Display Lighthouse Accounts for filling in Metamask Wallet.'
                },
                clear: {
                    title: 'Clear Cached Data',
                    description: 'For performance, all received PlexiMails are cached locally. They may grow excessively large.'
                },
                close: {
                    title: 'Close Your PlexiMail',
                    description: 'All data produced by this account will be permanently erased from canister',
                },
                backup_wallet: {
                    title: 'Backup Wallet',
                    description: ''
                
                },
                change_w3s_api_token: {
                    title: 'Migrate to a Different Web3Storage',
                    description: 'Storage space can be expanded in this way'
                },
                change_pin: {
                    title: 'Change PIN Code',
                    description: ''
                },
                verify_sender: {
                    title: 'Display Risk Level of Mail Sender',
                    description: 'Assess and display the risk level of the mail sender - this may impact performance.'
                },
                upgrade: {
                    title: 'Register with PlexiMail Blockchain',
                    description: 'Verify & Register with PlexiMail Smart Contract. This will incur smart contract charges in AVAX.'
                }
            },
            dialog: {
                export_confirm: {
                    title: 'Select Where to Export the Configuration',
                    content: 'Press "Export as a File" to package the Configuration as a file for manual download, or press "Sync to Your Phone" to encrypt and upload to your phone. ',
                    button: {
                        download: 'Export as a File',
                        sync: 'Sync to Your Phone'
                    }

                },
                sync: {
                    title: {
                        export: 'Backup Config Settings to Your Mobile Phone',
                        import: 'Import Config Settings from Your Mobile Phone'
                    },
                    content: {
                        paragraph1: 'Scan to connect to your phone',
                        paragraph2: 'Download and install the mobile app'
                    },
                    button: {
                        cancel: 'Cancel',
                        done: 'Done'
                    }
                },
                mnemonic: {
                    title: 'Display Mnemonic',
                    message: {
                        copied: 'Copied'
                    },
                    content: {
                        paragraph1: 'Click the mnemonic content above to copy to your clipboard.',
                        paragraph2: 'The mnemonic is most import'
                    },
                    button: {
                        hide: 'Hide Mnemonic',
                        display: 'Display Mnemonic',
                        copy: 'Copy to your clipboard',
                        close: 'Close'
                    }

                },
                privateKeys: {
                    title: 'Display Lighthouse Accounts',
                    message: {
                        copied: 'Copied'
                    },
                    content: {
                        paragraph1: 'Click the content above to copy to your clipboard.',
                        paragraph2: 'The account is most import'
                    },
                    button: {
                        hide: 'Hide Lighthouse Accounts',
                        display: 'Display Lighthouse Accounts',
                        copy: 'Copy to your clipboard',
                        close: 'Close'
                    }

                }
            }
        },
        profile: {
            title: 'Address',
            content: {
                copy: 'This QR image represents your PlexiMail Address, which is protected by the auto-generated passcode below it. Please take a screenshot or save the QR image as a file to share your PlexiMail Address. Click the eye icon to view and copy the auto-generated passcode. Send the passcode securely to your partner through a separate channel. Use two independent channels for the QR image and the passcode to ensure safe delivery.',
                note: 'Please keep the passcode hidden, If you share your address by taking a screenshot.',
            },
            message: {
                copied: 'Copied'
            },
            save: {
                title: 'Save as an Address Token',
                message: 'Encode your PlexiMail Address into a QR code file for passing along to your friends and partners.',
                checkbox: 'Scramble the file content with an optional passcode.',
                input: 'Please enter a passcode here',
                button: {next: 'Save', cancel: 'Cancel'}
            },
            button: {
                refresh: 'Regenerate the QR code',
                copy: 'Copy Address',
                close: 'Close',
                save: 'Save as an Address Token',
                back: 'Back'
            }

        },
        qrcode: {
            alert: {
                trigger: 'Scan',
                scan_message: 'Press “Open” for a QR code image file; “Scan” if the QR code is readable through the camera.',
                decode_message: 'Press “Decode” to decode the selected file.',
                cancel: 'Cancel',
                decode: 'Decode',
                next: 'Next'
            },
            pwd: {
                title: 'A passcode is required',
                message: 'The code passed in was encrypted for privacy protection. Please enter the decryption passcode. Contact the sender for one if you don’t have it.',
                input: 'Please enter passcode here',
                button: {
                    cancel: 'Cancel',
                    next: 'Decrypt'
                }
            },
            zip: {
                title: 'A password is required',
                message: 'The password passed in was encrypted for privacy protection. Please enter the decryption password.',
                input: 'Please enter password here',
                button: {
                    cancel: 'Cancel',
                    next: 'Open'
                }
            },
            scanner: {
                title: 'Scan QR Code',
                message: 'Please aim your camera at the QR Code.',
                button: {cancel: 'Cancel'}
            },
            button: {open: 'Open', scan: 'Scan'}
        },
        contacts: {
            title: 'Contacts',
            editTitle: 'Edit Contact',
            addTitle: 'New Contact',
            previewTitle: 'Contact',
            content: {
                list: {
                    search: {
                        placeholder: 'Search...'
                    },
                    new_contact: 'New',
                    empty: 'No contacts'
                },
                editor: {
                    name: 'Name: ',
                    email: 'PlexiMail Address: ',
                    save: 'Save',
                    back: 'Back',
                    delete: 'Delete'
                },
                preview: {
                    name: 'Name: ',
                    email: 'PlexiMail Address: ',
                    back: 'Back'
                }
            },
            message: {
                empty_name: 'Name could not be empty',
                empty_email: 'PlexiMail address could not be empty',
                invalid_name: 'Name is invalid',
                invalid_email: 'PlexiMail address is invalid',
            }
        },
        buy_eth: {
            title: `Redeem Plexi Tokens for ${COIN_SYMBOL}`,
            head: 'Plexi Tokens',
            status: {
                unused: 'Unspent',
                redeemed: 'Spent',
                refunded: 'Refunded'
            },
            
            description: <Text fontSize="sm">To enhance privacy and minimize traceability, the Plexi Token Service enables you to anonymously purchase {COIN_SYMBOL} through a two-step process: Step 1: Outside this webpage, <Link color="#00aaff" textDecoration={"underline"} href="https://ai-fi.cc/store" target="_blank">visit the token store to acquire anonymized tokens.</Link> Make sure to keep this webpage open or bookmark it to return for Step 2. Step 2: Once you have acquired the tokens, return here and redeem them by scanning into the list below. After scanning all the tokens, click the 'Redeem' button.   <br /><br /><i>The selected tokens to be redeemed are maintained below:</i></Text>,
            messages: {
                no_ecash: 'No Plexi Tokens',
                getting_current_price: `Getting current ${COIN_SYMBOL} price...`,
                current_price_1: `Current ${COIN_SYMBOL} price: $`,
                current_price_2: ` / ${COIN_SYMBOL}`,
                test_note: `This is a simulated process for purchasing Plexi Tokens for a testnet. The returned amount is fixed at 0.01 ${COIN_SYMBOL} regardless of the face value of the simulated purchases due to our limited supply of test coins.`
            },
            qrcode: {
                title: `Buy ${COIN_SYMBOL} with Plexi Tokens`,
                description: ''
            },
            table: {
                head: {
                    col0: '',
                    col1: 'Plexi Token',
                    col2: 'Face Value ($)',
                    col3: 'Status',
                    col4: 'Del'
                },
                body: {
                    empty_title: 'Tokens list to redeem is empty',
                    empty: 'Press the "Scan" button to add Plexi Tokens to the redemption list here'
                },
                foot: {
                    prefix: 'Total: $',
                    suffix: ` ${COIN_SYMBOL}` 
                }
            },
            foot: {
                buy_ecash: 'Buy Plexi Tokens',
                buy_eth: 'Redeem',
            }
        }
    }
    // slide.1.paragraph.1
})

export default Strings;
